import * as jsxRuntime from "/Users/zerone/actions-runner/_work/realworld-studio/realworld-studio/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment